/**
 * Editor decorations. Currently: highlight the paragraph containing the caret
 * (a subtle current-element cue). allcaps rendering is handled purely in CSS
 * (text-transform) driven by the per-style data-style rules; stored uppercase
 * is applied on retype and at save time, avoiding IME interference.
 */
import { Plugin } from "prosemirror-state";
import { Decoration, DecorationSet } from "prosemirror-view";

export function currentElementHighlight(): Plugin {
  return new Plugin({
    props: {
      decorations(state) {
        const { $from, empty } = state.selection;
        if (!empty) return DecorationSet.empty;
        // Find the enclosing para.
        for (let d = $from.depth; d >= 0; d--) {
          const node = $from.node(d);
          if (node.type.name === "para") {
            const start = $from.before(d);
            const end = start + node.nodeSize;
            return DecorationSet.create(state.doc, [
              Decoration.node(start, end, { class: "sp-current-para" }),
            ]);
          }
        }
        return DecorationSet.empty;
      },
    },
  });
}
